var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointerdown = function SvgPointerdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 6.8 3.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2.9 6.3 0l.5.5-3.4 3.4L0 .5.5 0z"
  })));
};
export default SvgPointerdown;